import type { Site } from '../Site';

export const YachtingAndBoatingWorld: Site = {
  id: 'ybw',
  logo: 'ybw.jpg',
  label: 'Yachting & Boating World',
  analyticsName: 'ybw',
  hostname: 'ybw.com',
  platform: 'ti',
  selector: '#content a',
};
